import { FC, PropsWithChildren, HTMLAttributes } from 'react'

export type RadioGroupProps = PropsWithChildren<{
  label: string
  hasError?: boolean
}> &
  HTMLAttributes<HTMLFieldSetElement>

export const RadioGroup: FC<RadioGroupProps> = ({ children, label, hasError = false, ...rest }) => (
  <fieldset {...rest}>
    <legend className="font-semibold text-ink-800">{label}</legend>
    <div
      className={`bg-white flex flex-col rounded-md${
        hasError ? ' border-red-600 border-2 outline-red-600 focus:border-red-600' : ''
      }`}
    >
      {children}
    </div>
  </fieldset>
)
